import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=6e5e64cd&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=6e5e64cd&prod&lang=scss&scoped=true"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=6e5e64cd&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5e64cd",
  null
  
)

export default component.exports